<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Convenzione #' + this.$route.params.id : 'Nuova convenzione')">

                    <b-container fluid class="mx-auto text-left" v-if="showdettaglio2 && (showdettaglio1 || this.$route.params.id == null)">
                         <b-row class="my-1">
                                    <b-col sm="3"><label for="nominativo">Nominativo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="convenzione.nominativo" id="nominativo" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="descrizione">Descrizione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="descrizione" v-model="convenzione.descrizione" :rows="2"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="(convenzione.voto > 0)">
                                    <b-col sm="3"><label for="voto">Voto medio:</label></b-col>
                                    <b-col sm="9">
                                        <star-rating id="voto" v-model="convenzione.voto" read-only :increment="0.01" :star-size="25" :show-rating="true"></star-rating>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="indirizzo">Indirizzo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="convenzione.indirizzo" id="indirizzo" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="note">Note:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="note" v-model="convenzione.note" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="sitoweb">Sito web:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="convenzione.sitoweb" id="sitoweb" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="facebook">Facebook:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="convenzione.facebook" id="facebook" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="coordinate">Coordinate:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="convenzione.coordinate" id="coordinate" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="telefono">Telefono:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="convenzione.telefono" id="telefono" type="text"></b-form-input>
                                    </b-col>
                                </b-row>                                
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="gruppowa">Link gruppo WhatsApp:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="convenzione.gruppowa" id="gruppowa" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="email">Email:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="convenzione.email" id="email" type="email"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datainizio">Data inizio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="convenzione.datainizio" id="datainizio" type="date"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datafine">Data fine:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="convenzione.datafine" id="datafine" type="date"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="categoria">Categoria:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="convenzione.id_categoria" :options="options_categorie" id="categoria">
                                            <template slot="first">
                                                      <!-- this slot appears above the options from 'options' prop -->
                                                      <option :value="null" disabled>-- Seleziona --</option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="visibilità">Visibilità:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="convenzione.visibilita" :options="options_visibilità" id="visibilità">
                                            <template slot="first">
                                                      <!-- this slot appears above the options from 'options' prop -->
                                                      <option :value="null" disabled>-- Seleziona --</option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-3">
                                    <b-col sm="5" offset-sm="3" v-show="convenzione.id != null">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="voti()">
                                            Voti
                                        </b-button>
                                    </b-col>
                                    <b-col sm="4" v-show="convenzione.id != null">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="allegatiImmagini()">
                                            Allegati e immagini
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="5" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="convenzione.id != null">
                                                Salva
                                            </div>
                                            <div v-else>
                                                Inserisci
                                            </div>
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    Categoria,
    Visibilità
} from '../classes.js'

import {
    ctrlVismenu,
    ctrlViscategoria
} from '../util.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {
                        
            namespace: NAMESPACE,
            convenzione: {
                id: this.$route.params.id || null,
                id_categoria: null,
                //visibilita: null,
                visibilita: '', //'T', //forzatura per inserimento massivo da togliere
                nominativo: '',
                descrizione: '',
                indirizzo: '',
                note: '',
                sitoweb: '',
                facebook: '',
                coordinate: '',
                telefono: '',
                email: '',
                gruppowa: '',
                //datainizio: '',
                //datafine: '',
                datainizio: '', //'2017-01-01', //forzatura per inserimento massivo da togliere
                datafine: '', //'2018-12-31', //forzatura per inserimento massivo da togliere
                voto: 0
            },
            options_categorie: [],
            options_visibilità: [],
            flagTipo: '',
            error: '',
            showerror: false,
            showdettaglio1: false,
            showdettaglio2: false,
            dismissSecs: 5,
            dismissCountDown: 0          
        };
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        allegatiImmagini() {

            this.$router.push({
                path: `/app/allegati/id/${this.convenzione.id}/tipo/${this.flagTipo}`
            });

        },
        voti() {

            this.$router.push({
                path: `/app/voti/id/${this.convenzione.id}/tipo/${this.flagTipo}`
            });

        },
        insert() {

                var appdettaglio = this;

                if (this.convenzione.nominativo == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo nominativo vuoto!";

                } else if (this.convenzione.descrizione == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo descrizione vuoto!";

                } else if (this.convenzione.datainizio == "" || this.convenzione.datainizio == null) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data inizio vuoto!";

                } else if (this.convenzione.datafine == "" || this.convenzione.datafine == null) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data fine vuoto!";

                } else if (this.convenzione.datafine < this.convenzione.datainizio) { //sono stringhe yyyy-mm-dd
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Data inizio maggiore di data fine!";

                } else if (this.convenzione.id_categoria == null) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Categoria non selezionata!";

                } else if ((this.convenzione.visibilita || '') == '') {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Visibilità non selezionata!";

                } else {

                    var json = JSON.stringify(this.convenzione);

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/convenzione', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        this.convenzione = res[0];
                                        this.showerror = false;
                                        this.showdettaglio1 = this.showdettaglio2 = true; //anche se non dovrebbe servire                                 
                                        this.dismissCountDown = this.dismissSecs;

                                        //window.location.search = "?id=" + this.convenzione.id;
                                        //this.$route.params.id = this.convenzione.id;

                                        this.$router.replace('/app/dettaglioconvenzione/' + this.convenzione.id);

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                this.showerror = true;
                                this.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            this.showerror = true;
                            this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });

                }

            }


    },
    created: function () {

            if(!ctrlVismenu("C")){
                this.$router.replace('/accessdenied');
                return;
            }



            var id = this.convenzione.id; //se è la prima volta si prova a prendere da getid 

            var appdettaglio = this;

            if (id != null) {

                var token = localStorage.getItem('token');                

                this.axios.get(NAMESPACE + 'rest/convenzioni/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.convenzione = res[0];
                                    this.showdettaglio1 = true;


                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

             //////////////////////////////////////
            const tipoPagina = 'Convenzione';
            //////////////////////////////////////

            //creo la tendina visibilità
            var visibilità = new Visibilità();
            var options_vis = [];
            for (var i = 0; i < Object.keys(visibilità.getListaTipi()).length; i++) {
                options_vis.push({
                    value: Object.keys(visibilità.getListaTipi())[i],
                    text: visibilità.getTipoByFlag(Object.keys(visibilità.getListaTipi())[i])
                });
            }
            this.options_visibilità = options_vis;

            //recupero il valore del flag del tipo della categoria
            var cat = new Categoria();
            var tipi = cat.getListaTipi();
            var keys = Object.keys(tipi);
            var flagTipo = "";
            for (var i = 0; i < keys.length; i++) {
                if (tipi[keys[i]] == tipoPagina) {
                    flagTipo = keys[i];
                }
            }

            this.flagTipo = flagTipo;

            //chiamo il servizio che mi restituisce tutte le categorie di quel tipo
            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/categorie/tipo/' + flagTipo, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {

                                var options = [];
                                for (var i = 0; i < res.length; i++) {
                                    options.push({
                                        value: res[i].id,
                                        text: res[i].descrizione
                                    });
                                }

                                this.options_categorie = options;

                                this.options_categorie = this.options_categorie.filter(function (element) {                       
                                    return ctrlViscategoria(element.value);
                                });

                                this.showdettaglio2 = true;

                            } else {
                                throw new Error("Errore categorie non trovate!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

    },
        mounted: function() {
            
          
            
        }

}
</script>
